import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { createErrorType } from '@atlassian/mpac-utils';
export function parseError(_x) {
  return _parseError.apply(this, arguments);
}

function _parseError() {
  _parseError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var _error$response;

    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!error.response) {
              _context.next = 18;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return error.response.json();

          case 4:
            response = _context.sent;
            _context.next = 18;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            _context.prev = 9;
            _context.next = 12;
            return error.response.text();

          case 12:
            response = _context.sent;
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t1 = _context["catch"](9);
            console.error('parseError: failed to parse response', error);

          case 18:
            return _context.abrupt("return", {
              status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
              response: response
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7], [9, 15]]);
  }));
  return _parseError.apply(this, arguments);
}

export function makeAPIError(_ref) {
  var name = _ref.name,
      code = _ref.code,
      response = _ref.response;
  var APIError = createErrorType(name);
  return new APIError({
    code: code,
    message: "".concat(name, " error"),
    meta: {
      response: response
    }
  });
}